import $ from 'jquery';


/**
 * from head.js
 */
function scriptTag(src, callback) {

    var s = document.createElement('script');
    s.type = 'text/' + (src.type || 'javascript');
    s.src = src.src || src;
    s.async = false;

    s.onreadystatechange = s.onload = function() {
        var state = s.readyState;

        if (!callback.done && (!state || /loaded|complete/.test(state))) {
            callback.done = true;
            callback();
        }
    };

    // use body if available. more safe in IE
    (document.body || document.head).appendChild(s);
}


/**
 * smsmemo.ru popup
 */
const Smsmemo = new (function () {
    var script_loaded = false;

    this.main = function () {
        $("a.smsmemo").click(function (e) {
            var a = this;
            e.preventDefault();

            var cb = function () {
                OpenWindowSmsMemo(a, 730, 550, 'Периодические СМС напоминания');
            };

            if (script_loaded) {
                cb();
            } else {
                $('<link rel="stylesheet" type="text/css" href="http://smsmemo.ru/jssmsmemo/smsmemopop.css"/>')
                    .appendTo($('body'));
                scriptTag('http://smsmemo.ru/jssmsmemo/smsmemopop.js', cb);
            }
        });
    };
})();

export default Smsmemo;



// WEBPACK FOOTER //
// ./site/js/smsmemo.js